<template>
  <div>
    <div class="red_top_bg">
        <div class="back_left" @click="$router.back()">
        </div>
        <div class="big_tit">合同详情</div>
        </div>    
    <div  class="content">
        <div  class="contract_box">
        <h1  class="con_name">西信科技有限公司租赁合同书</h1>
        <uni-view  class="vi code">合同编号：{{data.number}}</uni-view>
        <uni-view  class="vi">甲方（租赁方）：{{data.invester_name}}</uni-view>
        <uni-view  class="vi">乙方（管理方）：西信科技有限公司</uni-view>
        <uni-view  class="vi">丙方（担保方）：中國太平洋保險(香港)有限公司</uni-view>
        <uni-view  class="vi">甲乙丙双方经友好协商，本着平等自愿、诚实信用的原则，就甲方使用乙方提供的本网站所有服务的</uni-view>
        <uni-view  class="vi">有关事项达成如下协议：</uni-view>
        <uni-view  class="vi">一、加盟租赁明细</uni-view>
        <table  class="tablec">
            <tr >
            <td >产品名称</td>
            <td >{{data[lang]}}</td>
            </tr>
            <tr >
            <td >租赁人姓名</td>
            <td >{{data.invester_name}}</td>
            </tr>
            <tr >
            <td >租赁人身份证</td>
            <td >{{data.idcard}}</td>
            </tr>
            <tr >
            <td >投入本金数额
                <br >（下称"甲方租赁本金"）</td>
            <td >{{data.money}}元</td>
            </tr>
                <tr  v-if="data.type==1">
                <td >协议期（天）</td>
                <td >{{data.day}}天</td>
            </tr>
            </tr>
                <tr  v-if="data.type==2">
                <td >协议期（小时）</td>
                <td >{{data.day}}小时</td>
            </tr>            
            <tr >
            <td >预期收益率</td>
            <td >{{data.rate}}%</td>
            </tr>
            <tr >
            <td >起息日</td>
            <td >{{data.time3}}</td>
            </tr>
            <tr >
            <td >到期日</td>
            <td >{{data.time4}}</td>
            </tr>
            <tr >
            <td >应收本息（元）</td>
            <td >{{data.receivable}}元</td>
            </tr>
            <tr >
            <td >还款方式</td>
            <td >到期还本还息</td>
            </tr>
            <!---->
            <tr >
            <td >项目描述</td>
            <td >{{data.describe}}
            </td>
            </tr>
        </table>
        <uni-rich-text >
            <div style="position: relative;">
            <p >二、认购期未满，甲乙双方不得擅自终止本协议，如有违反规定，由此所引起的一切损失由擅自终止方承担。</p>
            <p >三、认购方式以平台系统自动化的形式进行操作。由于甲方全权委托乙方运营，因此所有经营风险由乙方承担，并由担保公司对此合同的租赁金额及租赁利润进行全额承保。收益分润按照乙方公布的认购参数，如约按期足额发放到甲方账户，待认购租赁周期日止。用户在使用西信科技APP服务时，须遵守平台的认购规则，有的项目是需要认购多份或认购关联项目的，用户须按要求认购，对于无特殊理由不按照要求认购的，平台将按照认购规则限制该账号的部分功能，在该用户按照要求认购后恢复该账号的正常使用。</p>
            <p >四、乙方对甲方认购资金负有控制风险的责任，必须勤勉尽责。如果租赁有亏损情况，则无论亏损大小由乙方承担全部损失，按合同承诺付款给甲方。如果乙方出现违约将由担保方履行承诺付款给甲方。</p>
            <p >五、保密义务甲乙双方对其通过接触和通过其他渠道得知的有关各方的商业机密等严格保密，对所有资料严格保密，不得向任何其他人员及机构透露相关信息等。</p>
            <p >六、合同生效</p>
            <p >1、本协议经甲方通过线上平台点击确认认购后自动生成并签订，本协议自生成时生效。</p>
            <p >2、本协议履行期间，各方如发生争议或者纠纷，应友好协商解决;如协商不成，任何一方有权向乙方所在地人民法院起诉。</p>
            <p >3、本协议采用电子文本形式制成，各方均认可该形式的法律效力。</p>
            <p >七、本协议-式三份，甲方一份，乙方一份，担保方方一份，具有同等法律效力。</p>
            <p >【以下无正文】</p>
            <uni-resize-sensor>
                <div>
                <div>
                </div>
                </div>
                <div>
                <div>
                </div>
                </div>
            </uni-resize-sensor>
            </div>
        </uni-rich-text>
        <uni-view  class="signature" style="float: left;">
            <uni-view  class="Party">
            <p >甲方：{{data.invester_name}}</p>
            <span >{{data.time3}}</span>
            </uni-view>
        </uni-view>
        <uni-view  class="signature" style="float: right;">
            <uni-view  class="Party">
            <p >乙方：西信科技有限公司</p>
            <span >{{data.time3}}</span>
            </uni-view>
            <uni-image  class="htz">
            <div style="background-image: url(&quot;/upload/contract.png&quot;); background-position: 0% 0%; background-size: 100% 100%; background-repeat: no-repeat;">
            </div>
            <!---->
            <img src="/upload/contract.png" draggable="false">
            </uni-image>
        </uni-view>
        <uni-view  class="signature" style="float: left;">
            <uni-view  class="Party">
            <p >丙方：中國太平洋保險(香港)有限公司</p>
            <span >{{data.time3}}</span>
            </uni-view>
            <uni-image  class="htz">
            <div style="background-image: url(&quot;/upload/contract1.png&quot;); background-position: 0% 0%; background-size: 100% 100%; background-repeat: no-repeat;">
            </div>
            <!---->
            <img src="/upload/contract1.png" draggable="false">
            </uni-image>
        </uni-view>
        </div>
    </div>
</div> 
</template>

<script>
	import Vue from "vue";
	import {Empty} from "vant";
	import Fetch from "../../utils/fetch";
	Vue.use(Empty);
	import { Popup } from 'vant';
	Vue.use(Popup);	

	export default {
		name: "contract",
		data() {
			return {
				lang: this.$i18n.locale || "zh_cn",
				data: {},
                id:'',
			};
		},
		created() {
			this.$parent.footer("user", false);
		},
        
		mounted() {
            this.getparams();
			this.start();
		},
		methods: {
            getparams() {
                var id = this.$route.query.id;
                this.id = id;
            },            
			start() {
				Fetch("/user/contract",{id:this.$route.query.id}).then((r) => {
					this.data = r.data;
				});
			}
		},
	};
</script>

<style lang="less" scoped>
.content{
    margin:10px;
    line-height: normal!important;
    font-size: 14px;
}
.signature{
    height:72px;
    margin-top:20px;
    text-align:right
}
.signature .Party{
    margin-top:10px
}
.signature .htz{
    width:104px;
    height:104px;
    position:relative;
    top:-78px;
    right:5px
}
.con_name{
    font-size:24px;
    text-align:center
}
.code{
    margin-top:10px
}
.vi{
    min-height:31px;
    display: block;
}
.tablec{
    border:1px solid #ccc;
    border-collapse:collapse
}
.tablec, th, td{
    border:1px solid #000;
    padding:10px
}
uni-image {
    display: inline-block;
    overflow: hidden;
    position: relative;
}
uni-view {
    display: block;
}
.red_top_bg{width:100%;max-width:750px;height:44px;margin:0 auto;background:#fff;background-size:100% 100%;overflow:hidden;}
.big_tit{position:absolute;height:25px;font-size:18px;font-weight:500;color:#fff;line-height:25px;top:12px;left:50%;transform:translateX(-50%);}
.back_left{width:20px;height:20px;background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAoCAMAAADNGvrUAAAAS1BMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////+DmQsHAAAAGHRSTlMABwkTICssLS9FaHZ9iI6PzNri6erv9/4ppXzqAAAAVElEQVQoz+3TORKAIBAAwfUAb0EFnf+/1NxdH0AVE3Y+It9czItC8Qme3lLNPgFspoaqpjpTJZoqGbgHxSvA5ZWHkjwV4mdr+6jn2eFoNMs0d/LTCzd6E3GEJ9CYAAAAAElFTkSuQmCC) no-repeat 50%;background-size:auto 100%;margin:12px 0 0 8px;}
div,p,span{margin:0;padding:0;border:0;font-size:100%;outline:none;-webkit-appearance:none;border:none;box-sizing:border-box;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-text-size-adjust:none;word-break:break-all;}
.red_top_bg{background:#3775f4;background-size:100% 100%;position:fixed;z-index:15;}
.money_box{margin-top:29px;display:flex;padding:0 6px;justify-content:space-around;color:#fff;}
.money_box .item{width:33.33%;text-align:center;font-weight:700;}
.money_box .item .money_num{font-size:18px;line-height:25px;white-space:normal;word-break:normal;text-align:center;}
.money_box .item .info{font-size:14px;line-height:20px;margin-top:5px;}
</style>
